import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Glyphicon} from 'react-bootstrap';

const ArticleHeader = ({
  featured = false, date, textColor, category
}) => (
  <div className={classnames('header', textColor)}>
    {featured && <Glyphicon className="pull-left" glyph="star"/>}
    <span className="pull-right">
      {category.name.toLowerCase() !== 'about ignite' && category.name.toLowerCase() !== 'how to earn' && date}
    </span>
  </div>
);

ArticleHeader.propTypes = {
  featured: PropTypes.bool,
  date: PropTypes.string,
  textColor: PropTypes.string,
  category: PropTypes.object
};

export default ArticleHeader;




// WEBPACK FOOTER //
// ./src/components/common/article/article-header.jsx